import { pipe } from 'fp-ts/lib/function';
import { removeDuplicates } from '../../utils/removeDuplicates';
import { isValidIPv6 } from './ipAddressValidations';
import { removeIPv6Duplicates } from './removeIPv6Duplicates';

export const extractIpAddresses = (addresses: string) =>
  addresses
    .split(/[,\s]/)
    .map((v) => v.trim())
    .filter(Boolean);

export const serializeIpAddresses = (addresses: string[], whitespace = false) =>
  addresses.join(whitespace ? ', ' : ',');

export const filterIpAddresses = (text: string, ipList: string[]): string[] => {
  return ipList.filter((item) => {
    return item.includes(text.toLowerCase());
  });
};

export const sortIpAddresses = (addresses: string[]): string[] => {
  return addresses.sort((a, b) => {
    const aIsV6 = isValidIPv6(a);
    const bIsV6 = isValidIPv6(b);
    if (aIsV6 && !bIsV6) {
      return -1;
    }
    if (!aIsV6 && bIsV6) {
      return 1;
    }
    return 0;
  });
};

export const mergeAndSortUniqueIpAddresses = (
  originalAddresses: string[],
  newAddresses: string[],
) =>
  pipe(
    newAddresses.map((address) => address.toLowerCase()),
    (addresses) => originalAddresses.concat(addresses),
    removeDuplicates,
    removeIPv6Duplicates,
    sortIpAddresses,
  );
